import { render, staticRenderFns } from "./Providerlist.vue?vue&type=template&id=4ad31800&"
import script from "./Providerlist.vue?vue&type=script&lang=js&"
export * from "./Providerlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports